import React from 'react';
import { View } from 'react-native';

import { Charge as ChargeType } from 'apollo/queries/autogenerate/schemas';
import ChargeItem from 'shared/modules/common/components/organisms/ChargeItem';
import Separator from 'shared/modules/usage/components/molecules/ListItemDivider';
import ListSection from 'shared/modules/usage/components/molecules/ListSection';

type Props = {
  onItemPress: (charge: ChargeType) => void;
  data?: ChargeType[];
  error?: any;
};

const RecentDebits = ({ onItemPress, data = [], error }: Props) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <ListSection
      title="払い戻し"
      emptyMessage={data.length ? '' : 'ご利用はありません。'}
      errorMessage={error ? 'ネットワークエラー' : ''}
    >
      {data.map((charge, index) => (
        <View key={charge.id}>
          <ChargeItem charge={charge} onPress={onItemPress} />
          {index !== data.length - 1 && <Separator />}
        </View>
      ))}
    </ListSection>
  );
};

export default RecentDebits;
